
import React, { FC } from 'react'
import { IOrderInProgress } from "../../../../models/order/aggregates/progress/IOrderInProgress"
import { OrderInProgressItem } from './orderInProgressItem/OrderInProgressItem'
import "./OrdersInProgressList.css"
import { useI18n } from 'utils/i18n/hooks/useI18n';
interface IOrdersInProgressListProps {
    ordersInProgressList: IOrderInProgress[]
}

export const OrdersInProgressList: FC<IOrdersInProgressListProps> = ({ ordersInProgressList }) => {
    const { t } = useI18n();
    
    return (
        <div id="ordersInProgressList">
            <div className="container">
                {!!ordersInProgressList.length ?
                    <div className="list">
                        {ordersInProgressList.map((orderInProgress, index) => (<OrderInProgressItem key={index} orderInProgress={orderInProgress} />))}
                    </div>
                    :
                    <div className={"alertaVazio"}>
                        {t("orders.status.noOrdersInProgress")}
                </div>
                }
            </div>
        </div>
    )
}
